<template>
    <div class="w-100 d-flex flex-column" style="height: 90vh;">
        <Navigation pageName="sessions" />
        <!-- PANNELLO SESSIONI-->
        <div id="all_sessions" class="p-5 w-100 mt-4 overflow h-100">
            <!--form @submit.prevent="getSessions()"-->
            <div v-if="!loading">
                <div class="row">
                    <button class="button secondary" @click="showFilters = !showFilters"><span class="mif-filter"></span><span>{{ $t("Filters") }}</span></button>
                    <button class="button secondary ml-2" @click="exportSessionsToExcel()"><span class="mif-file-download mif-2x"></span><span>{{ $t("Export to XLS") }}</span></button>
                </div>
            </div>
            <!--FILTRI (su 3 colonne)=-->
            <div v-if="showFilters" class="sessions-filters mt-2 p-4 h-fit bg-white d-flex flex-justify-between mb-2">
                <!--FILTRI - CERCA / DA / CHECKBOX-->
                <div class="w-30">
                    <div class="p-0 w-100 mb-2">
                        <label class="text-bold">{{ $t("Search") }}</label>
                        <input type="text" data-role="input" data-clear-button="true" :placeholder="$t('Please enter at least 4 characters to start the search.')" v-model="searchTerm" class="w-100 p-0">
                    </div>
                    <div class="w-100">
                        <label class="text-bold">{{ $t("Operator") }}</label>
                        <select class="select text-small" id="id_user" v-model="filters.id_user">
                            <option selected="selected" value="">{{ $t("All operators") }}</option>
                            <option v-for="user in users" :value="user.id" :key="user.id">
                                {{ user.firstname }} {{ user.lastname }} ({{ user.username }})
                            </option>
                        </select>
                    </div>
                    <div class="w-100">
                        <input type="checkbox" data-role="checkbox" class="w-100" v-model="filters.include_nig" :data-caption="$t('Include remote devices not in the address book')">
                        <input type="checkbox" data-role="checkbox" class="w-100" v-model="filters.order_by_idhost" :data-caption="$t('Group by remote device')">
                    </div>
                </div>

                <!--FILTRI - GROUP / A-->
                <div class="w-30">
                    <div class="w-100 mb-2">
                        <label class="text-bold">{{ $t("From") }}</label>
                        <input type="date" class="date select text-small" style="width: auto;" v-model="filters.dt_inf" min="2018-01-01" :max="Date.now() | moment('YYYY-MM-DD')">
                        </input>
                    </div>
                    <div class="w-100 mb-2">
                        <label class="text-bold">{{ $t("Destination group") }}</label>
                        <select class="select text-small" id="id_group" v-model="filters.id_group">
                            <option selected="selected" value="">{{ $t("All Groups") }}</option>
                            <option v-for="group in groups" :value="group.id_group" :key="group.id_group">
                                {{ group.name_group }}
                            </option>
                        </select>
                    </div>


                </div>
                <!--FILTRI - UTENTE / BUTTON-->
                <div class="w-30">
                    <div class="d-flex flex-column h-100">
                        <div class="w-100 mb-2">
                            <label class="text-bold"> {{ $t("To") }}</label>
                            <input type="date" class="date select text-small" style="width: auto;" v-model="filters.dt_sup" min="2018-01-01" :max="Date.now() | moment('YYYY-MM-DD')">
                            </input>
                        </div>
                        <div class="w-100">
                            <label class="text-bold">{{ $t("Destination host") }}</label>
                            <select class="select text-small" id="id_pc" v-model="filters.id_host" :disabled="!selectedGroup">
                                <option selected="selected" value="">{{ $t("All hosts") }}</option>
                                <option v-for="pc in computersInSelectedGroup" :value="pc.id" :key="pc.id">
                                    {{ pc.pc_name }}
                                </option>
                            </select>
                        </div>
                        <div class="w-100 d-flex flex-justify-end flex-align-end" style="height: 88px;">
                            <button @click="getSessions()" class="button secondary" :disabled="loading">
                                <span v-if="loading" class="mif-spinner2 ani-spin mr-1"></span>
                                {{ $t("Apply filters") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <!--/form-->
            <div>
                <div v-if="loading" class="sessions-loading w-100 text-center" role="status" aria-live="polite">
                    <span class="mif-spinner2 ani-spin mif-3x"></span>
                </div>
                <NoDataAvailable v-else-if="filteredSessions.length == 0" :message="$t('No sessions available for the selected dates')" />
                <table v-else id="session-list" class="border bg-white compact table w-100 mt-2">
                    <thead class="mb-0">
                        <tr class="mb-3">
                            <th class="pl-5 sortable-column" style="vertical-align: middle;" tabindex="0" :aria-sort="ariaSort('firstname')" @click="toggleSort('firstname')" @keydown.enter.space.prevent="toggleSort('firstname')">
                                {{ $t("Operator") }}
                                <span v-if="sortKey === 'firstname'" class="ml-1" :class="sortDirection === 'asc' ? 'mif-sort-asc' : 'mif-sort-desc'"></span>
                            </th>
                            <th class="text-center sortable-column" style="vertical-align: middle;" tabindex="0" :aria-sort="ariaSort('name_computer_control')" @click="toggleSort('name_computer_control')" @keydown.enter.space.prevent="toggleSort('name_computer_control')">
                                {{ $t("Source") }}
                                <span v-if="sortKey === 'name_computer_control'" class="ml-1" :class="sortDirection === 'asc' ? 'mif-sort-asc' : 'mif-sort-desc'"></span>
                            </th>
                            <th class="text-center" style="vertical-align: middle;"></th>
                            <th class="text-center sortable-column" style="vertical-align: middle;" tabindex="0" :aria-sort="ariaSort('name_computer_host')" @click="toggleSort('name_computer_host')" @keydown.enter.space.prevent="toggleSort('name_computer_host')">
                                {{ $t("Destination") }}
                                <span v-if="sortKey === 'name_computer_host'" class="ml-1" :class="sortDirection === 'asc' ? 'mif-sort-asc' : 'mif-sort-desc'"></span>
                            </th>
                            <th class="text-center no-wrap sortable-column" style="vertical-align: middle;" tabindex="0" :aria-sort="ariaSort('dt_start')" @click="toggleSort('dt_start')" @keydown.enter.space.prevent="toggleSort('dt_start')">
                                {{ $t("Started at") }} / {{ $t("Ended at") }}
                                <span v-if="sortKey === 'dt_start'" class="ml-1" :class="sortDirection === 'asc' ? 'mif-sort-asc' : 'mif-sort-desc'"></span>
                            </th>
                            <th class="text-center no-wrap" style="vertical-align: middle;">{{ $t("Duration") }}</th>
                            <th class="text-center no-wrap" style="vertical-align: middle;">{{ $t("Notes") }}</th>
                            <th class="text-center no-wrap" style="vertical-align: middle;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="pt-10" v-if="!filteredSessions">
                            <td class="p-6" colspan="10" data-role="activity" data-type="metro" data-style="dark"></td>
                        </tr>
                        <!--inizio codice vero-->
                        <template v-for="(session, index) in filteredSessions">
                            <tr v-if="order_by_idhost && shouldBeAddedAfter(session) && index != 0 && sessionrow != 0">
                                <td colspan="10" class="text-bold bg-light border border-top-none"> {{ $t("Sessions") }} : {{ sessionrow }}</td>
                            </tr>
                            <tr v-if="order_by_idhost && shouldBeAddedBefore(session)" class="bg-primary ">
                                <td colspan="10" class="fg-white text-bold"> {{ session.name_computer_host }} ({{ session.custom_name }})</td>
                            </tr>
                            <tr class="session-row">
                                <td class="text-bold text-left pl-5 no-wrap">
                                    {{ session.firstname + " " + session.lastname }}
                                </td>
                                <td class="session-identity text-center">
                                    <div class="session-cell-content">
                                        <div class="row">
                                            <div class="session-endpoint-name mr-1">{{ session.name_computer_control }}</div>
                                            <div class="session-remote-id">({{ IDRemoteWithSpace(session.id_remote_control) }})</div>
                                        </div>
                                        <div>{{ session.ip_wan_control }} - {{ session.ip_lan_control }}</div>
                                    </div>
                                </td>

                                <td class="session-direction"><span class="mif mif-2x mif-arrow-right text-center"></span></td>
                                <td class="session-identity text-center">
                                    <div class="session-cell-content">
                                        <div class="row">
                                            <div class="session-endpoint-name mr-1">{{ session.name_computer_host }}</div>
                                            <div class="session-remote-id">({{ IDRemoteWithSpace(session.id_remote_host) }})</div>
                                        </div>
                                        <div v-if="showCustomName(session)">{{ session.custom_name }}</div>
                                        <div v-if="session.organization_name">{{ session.organization_name }}</div>
                                        <div>{{ session.ip_wan_host }} - {{ session.ip_lan_host }}</div>
                                    </div>
                                </td>

                                <td class="text-center no-wrap">
                                    <label v-if="session.dt_start != '' && session.dt_start != null">{{ session.dt_start.toLocalDate() }}</label><br>
                                    <label v-if="session.dt_end != '' && session.dt_end != null">{{ session.dt_end.toLocalDate() }}</label>
                                </td>
                                <td class="text-right"><label class="text-bold" v-if="session.dt_end != '' && session.dt_end != null">{{ diffDate(session.dt_start, session.dt_end) }}</label></td>
                                <td class="text-center">
                                    <input v-if="session.notes[0]" type="text" data-role="input" v-model.trim="session.notes[0].note">
                                    <input v-else type="text" data-role="input" v-model.trim="session.notedesc">
                                </td>
                                <td>
                                    <button class="button small" @click="saveNote(session)">{{ $t("Save") }}</button>
                                </td>
                            </tr>
                        </template>
                        <tr v-if="sessionrow != 0">
                            <td colspan="10">
                                <div class="text-bold">{{ $t("Sessions") }} : {{ filteredSessions.length }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- FINE PANNELLO SESSIONI -->
    </div>
</template>
<script>

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Navigation from './utils/Navigation.vue';
import NoDataAvailable from "./utils/NoDataAvailable.vue";
import { diffDate, fromNow, insertSpacesEveryThreeDigits } from '../utils/utilitiesmodule';
import { PC_MESSAGES } from '../utils/messages';
export default {
    name: "Sessions",
    components: {
        Navigation,
        NoDataAvailable
    },

    data() {
        return {
            groups: null,
            filteredgroups: null,
            searchTerm: '',
            order_by_idhost: false,
            lang_code: localStorage.getItem('lang') ?? $i18n.locale ?? "en",
            filters: {
                firstline: true,
                lastline: false,
                sessionrow: 0,
                first_dt_start: 0,
                total_session_inarow: "",
                headergroupname: "",
                numrows: 25,
                offset: 0,
                lastresult: '',
                dt_inf: this.$moment().subtract(3, 'days').format('YYYY-MM-DD'),
                dt_sup: this.$moment().format('YYYY-MM-DD'),
                id_host: '',
                id_user: '',
                id_group: '',
                include_nig: false,
                order_by_idhost: false, // perché l'hai messo checked di default
                include_stats: "0",
            },
            sessions: [],
            users: null,
            groups: null,
            computers: null,
            sortKey: 'dt_start',
            sortDirection: 'desc',
            loading: true,
            showFilters: false
        }
    },
    created() {
        this.$session.setRoomPC(null);
        this.$root.socket("SETPC", null);
        //this.$store.commit('SET_LAYOUT', 'nav-layout')
        this.groups = this.$session.getGroups();
        this.users = this.$session.getUsers();
        this.computers = this.$session.getPCList();
        /*  this.$root.$on("finish", message => {
             var mss = message.split("|");
             self.$root.toast(this.$t(mss[0]), mss[1]);
         }); */
    },
    mounted: function () {
        this.headergroupname = "";
        this.sessionrow = 0;
        this.getSessions();


    },
    computed: {
        selectedGroup() {
            if (!this.filters.id_group || !Array.isArray(this.groups)) {
                return null;
            }

            return this.groups.find(group => group.id_group == this.filters.id_group) || null;
        },

        computersInSelectedGroup() {
            if (!this.selectedGroup || !Array.isArray(this.computers)) {
                return [];
            }

            return this.computers.filter(pc => this.groupHasPC(this.selectedGroup, pc.id));
        },

        filteredSessions() {
            let result = Array.isArray(this.sessions) ? [...this.sessions] : [];

            if (this.searchTerm && this.searchTerm.length >= 4) {
                const term = this.searchTerm.toLowerCase();

                result = result.filter(session => {
                    const fullName = `${session.firstname} ${session.lastname}`.toLowerCase();
                    const nameControl = (session.name_computer_control || '').toLowerCase();
                    const nameHost = (session.name_computer_host || '').toLowerCase();
                    const idRemoteControl = (session.id_remote_control || '').toString().toLowerCase();
                    const idRemoteHost = (session.id_remote_host || '').toString().toLowerCase();
                    const orgName = (session.organization_name || '').toLowerCase();
                    const networkAddresses = [
                        session.ip_wan_control,
                        session.ip_lan_control,
                        session.ip_wan_host,
                        session.ip_lan_host
                    ].filter(Boolean).join(' ').toLowerCase();

                    return (
                        fullName.includes(term) ||
                        nameControl.includes(term) ||
                        nameHost.includes(term) ||
                        idRemoteControl.includes(term) ||
                        idRemoteHost.includes(term) ||
                        orgName.includes(term) ||
                        networkAddresses.includes(term)
                    );
                });
            }

            if (this.sortKey) {
                const direction = this.sortDirection === 'asc' ? 1 : -1;
                const key = this.sortKey;

                result.sort((firstSession, secondSession) => {
                    if (key === 'dt_start') {
                        const firstDate = firstSession.dt_start ? new Date(firstSession.dt_start).getTime() : 0;
                        const secondDate = secondSession.dt_start ? new Date(secondSession.dt_start).getTime() : 0;
                        return (firstDate - secondDate) * direction;
                    }

                    return String(firstSession[key] || '').localeCompare(
                        String(secondSession[key] || ''),
                        undefined,
                        { sensitivity: 'base', numeric: true }
                    ) * direction;
                });
            }

            return result;
        },
    },
    watch: {
        'filters.id_group'() {
            this.filters.id_host = '';
        }
    },
    methods: {

        toggleSort(key) {
            if (this.sortKey === key) {
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortKey = key;
                this.sortDirection = key === 'dt_start' ? 'desc' : 'asc';
            }

            this.headergroupname = '';
            this.sessionrow = 0;
        },

        ariaSort(key) {
            if (this.sortKey !== key) {
                return 'none';
            }

            return this.sortDirection === 'asc' ? 'ascending' : 'descending';
        },

        groupHasPC(group, idPC) {
            return !!group &&
                Array.isArray(group.ids_computers) &&
                group.ids_computers.some(id => id == idPC);
        },

        IDRemoteWithSpace(value) {
            return insertSpacesEveryThreeDigits(value);
        },

        showCustomName(session) {
            const customName = (session.custom_name || '').trim().toLowerCase();
            const computerName = (session.name_computer_host || '').trim().toLowerCase();
            return customName !== '' && customName !== computerName;
        },

        saveNote(session) {

            let self = this;
            const note = {
                id_session: session.id,
                note: session['notes'].length == 0 ? session.notedesc : session['notes'][0].note,
                id: session['notes'].length == 0 ? null : session['notes'][0].id,
                hide_customer: 0
            }

            self.$api.saveNote(note).then((value) => {
                if (value) {
                    self.$root.toast(this.$t(PC_MESSAGES.NOTE_SAVED), "success")
                }
            });
            /*   if ($note["id"] == "") {
                  $response = $http -> post($this -> endpoint.'/api/notes', [
                      'id_session'=> $note["session_id"],
                      'note'=> $note["note"],
                      'hide_customer'=> 0
                  ]);
              } else {
                  $response = $http -> put($this -> endpoint.'/api/notes', [
                      'note'=> $note["note"],
                      'id'=> $note["id"]
                  ]);
              } */
        },

        runMethodWithDelay(callback, delay) {
            setTimeout(callback, delay);
        },

        openMenu() {
            Metro.getPlugin('#remotemenu', 'dropdown').open();
        },

        //metodo per controllare se devo aggiungere o meno la riga iniziale...
        shouldBeAddedBefore(session) {
            if (this.headergroupname == "" || session.name_computer_control != this.headergroupname) {
                this.headergroupname = session.name_computer_control;
                this.sessionrow = 1;
                this.total_session_inarow = session.total_time;
                return true;
            }
            if (session.name_computer_control == this.headergroupname) {
                this.total_session_inarow += session.total_time;
                this.sessionrow += 1;
                return false;
            }

        },
        shouldBeAddedAfter(session) {

            if (this.headergroupname != "" && session.name_computer_control != this.headergroupname) {
                this.sessionsrow = 0;
                return true;
            }
            return false;

        },

        fromNow(date) {
            if (date == null || date == "") return ""
            return fromNow(date, this.$moment);
        },
        diffDate(datestart, dateend) {
            return diffDate(datestart, dateend, this.$moment);
        },
        async getSessions() {
            this.loading = true;

            const obj = {

                id_user: this.filters.id_user,
                dt_inf: this.filters.dt_inf,
                dt_sup: this.filters.dt_sup,
                id_host: this.filters.id_host,
                id_group: this.filters.include_nig && this.filters.id_group === '' ? 'NIG' : this.filters.id_group,
                order_by_idhost: this.filters.order_by_idhost ? '1' : '0',
                include_stats: this.filters.include_stats
            }

            if (obj.id_user == null) {
                obj.id_user = '';
            }

            try {
                const res = await this.$api.getSessions(obj);
                this.order_by_idhost = this.filters.order_by_idhost;
                this.sessions = res || [];
                this.showFilters = this.sessions.length == 0;
            } finally {
                this.loading = false;
            }
        },

        // ESPORTAZIONE EXCEL

        exportTableToExcel(type = 'xlsx', filename = '') {

            const elt = document.getElementById('session-list');
            const wb = XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });

            if (filename === '') {
                filename = 'Stats_' +
                    this.getSelectedText('#id_group') + '_' +
                    this.getSelectedText('#id_user') + '_' +
                    this.filters.dt_inf + '_' +
                    this.filters.dt_sup + '.' + type;
            }

            XLSX.writeFile(wb, filename);

        },

        exportSessionsToExcel() {
            const wb = XLSX.utils.book_new();
            const ws_data = [
                ['User', 'Source Device ID', 'Source Device Name', 'Source WAN IP', 'Source LAN IP', 'Remote Device ID', 'Remote Device Name', 'Remote WAN IP', 'Remote LAN IP', 'Organization', 'Group', 'Start date', 'End Date', 'Duration', 'Note']
            ];

            this.sessions.forEach(sess => {
                let group_line = sess.group_name.split('|').join(' ');

                ws_data.push([
                    `${sess.firstname} ${sess.lastname}`,
                    sess.id_remote_control,
                    sess.name_computer_control,
                    sess.ip_wan_control,
                    sess.ip_lan_control,
                    sess.id_remote_host,
                    sess.custom_name || sess.name_computer_host,
                    sess.ip_wan_host,
                    sess.ip_lan_host,
                    sess.organization_name,
                    group_line,
                    this.formatDateString(sess.dt_start),
                    this.formatDateString(sess.dt_end),
                    sess.total_time,
                    sess.notes?.[0]?.note || ''
                ]);
            });

            const ws = XLSX.utils.aoa_to_sheet(ws_data);
            XLSX.utils.book_append_sheet(wb, ws, "Sessions");

            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
            const blob = new Blob([this.s2ab(wbout)], { type: "application/octet-stream" });

            const filename = 'Stats_' +
                this.getSelectedText('#id_group') + '_' +
                this.getSelectedText('#id_user') + '_' +
                this.filters.dt_inf + '_' +
                this.filters.dt_sup + '.xlsx';



            saveAs(blob, filename);
        },

        s2ab(s) {
            const buf = new ArrayBuffer(s.length);
            const view = new Uint8Array(buf);
            for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        },

        formatDateString(date) {
            // Implementa formattazione se non già gestita altrove
            return new Date(date).toLocaleString();
        },

        getSelectedText(selector) {
            const el = document.querySelector(selector);
            return el ? el.options[el.selectedIndex].text.trim() : '';
        },

        getInputValue(selector) {
            const el = document.querySelector(selector);
            return el ? el.value.trim() : '';
        }

    }
}



</script>

<style scoped>
.sessions-filters {
    position: relative;
    z-index: 4000;
    overflow: visible !important;
}

.sessions-filters>div {
    position: relative;
    overflow: visible !important;
}

.sessions-loading {
    display: flex;
    min-height: 180px;
    align-items: center;
    justify-content: center;
}

.sortable-column {
    cursor: pointer;
    user-select: none;
}

.sortable-column:hover {
    background-color: #f2f7fc;
}

.session-identity,
.session-technical {
    vertical-align: middle;
    padding-top: 12px;
    padding-bottom: 12px;
}

.session-cell-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.session-identity {
    min-width: 150px;
}

.session-technical {
    min-width: 180px;
    color: #444;
    font-size: 12px;
    line-height: 1.4;
}

.session-endpoint-name {
    font-weight: 600;
    line-height: 1.25;
}

.session-remote-id {
    margin-bottom: 4px;
    color: #666;
    font-size: 11px;
    letter-spacing: .2px;
    font-weight: 800;
}

.session-direction {
    width: 48px;
    padding: 0 12px;
    vertical-align: middle;
    text-align: center;
}

#session-list tbody .session-row>td {
    border-bottom: 1px solid #d8d8d8;
}

#session-list tbody .session-row:nth-child(even)>td {
    background-color: #fafafa;
}

#session-list tbody .session-row:hover>td {
    background-color: #f2f7fc;
}
</style>

<style>
#all_sessions .select.focused {
    z-index: 4100 !important;
}

#all_sessions .sessions-select-dropdown {
    z-index: 4101 !important;
    overflow: hidden;
    background: #fff !important;
    border: 1px solid #d9d9d9;
    box-shadow: 0 4px 10px rgba(0, 0, 0, .18);
}

#all_sessions .sessions-select-dropdown>div,
#all_sessions .sessions-select-dropdown .input,
#all_sessions .sessions-select-dropdown .option-list,
#all_sessions .sessions-select-dropdown .option-list li,
#all_sessions .sessions-select-dropdown .option-list li a {
    background-color: #fff;
}

#all_sessions .sessions-select-dropdown .option-list li.active,
#all_sessions .sessions-select-dropdown .option-list li.active a {
    background-color: var(--secondary);
}
</style>
